if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('no-inert') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header site-header';
				if ( this.classList.contains('site-header--absolute') ) {
					stickyHeader.classList.add('dark-mode');
				}
				const areaTokenEl = this.querySelector('.area--tokens');
				const areaCartEl = this.querySelector('.area--cart');
				const areaAccountEl = this.querySelector('.area--account, .header-auth-buttons.area--account');
				const areaDownloadEl = this.querySelector('.area--acount-download');
				const logoEl = this.querySelector('#logo');
				stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
					${logoEl ? logoEl.outerHTML : ''}
					<div class="sticky-nav-wrap" style="flex:1;min-width:0;display:flex;align-items:center;justify-content:center;">
						${this.querySelector('.header__bottom').innerHTML}
					</div>
					<div class="sticky-actions-wrap" style="display:flex;gap:12px;flex-shrink:0;position:relative;z-index:10;">
						${this.querySelector('.area--custom-icon') ? this.querySelector('.area--custom-icon').outerHTML : ''}
						${this.querySelector('.area--search').outerHTML}
						${areaDownloadEl ? areaDownloadEl.outerHTML : ''}
						${areaAccountEl ? areaAccountEl.outerHTML : ''}
						${areaCartEl ? areaCartEl.outerHTML : ''}
						${areaTokenEl ? areaTokenEl.outerHTML : ''}
					</div>
				</div>
				<div class="site-header element--hide-on-portable-plus">
					${this.querySelector('.header-container--top').innerHTML}
				</div>`;
				document.body.append(stickyHeader);

				// position:fixed uses viewport width (incl. scrollbar); page content uses
				// clientWidth (excl. scrollbar). Pad the sticky header right by the scrollbar
				// width so container--large centres the same way as page content, keeping the
				// logo and actions aligned with the rest of the page.
				(function applyStickyScrollbarPadding() {
					function update() {
						var sw = window.innerWidth - document.documentElement.clientWidth;
						stickyHeader.style.paddingRight = sw > 0 ? sw + 'px' : '';
					}
					update();
					window.addEventListener('resize', update, { passive: true });
				})();

				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('.site-nav [aria-controls]').forEach(elm=>{
					elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
				});

				// Give the logo flex-shrink:0 and z-index above nav links (z-index:9)
				// so overflowing nav items cannot cover it or block clicks.
				// Also set display:flex + align-items:center to match the original
				// .header__top .area--logo { display:flex } rule which the sticky
				// context loses, preventing an inline whitespace shift to the right.
				const stickyLogoDiv = stickyHeader.querySelector('#logo-sticky');
				if (stickyLogoDiv) {
					stickyLogoDiv.style.display = 'flex';
					stickyLogoDiv.style.alignItems = 'center';
					stickyLogoDiv.style.flexShrink = '0';
					stickyLogoDiv.style.position = 'relative';
					stickyLogoDiv.style.zIndex = '10';
				}

				// Explicitly patch hrefs in the sticky header so logo, login, and signup links
				// are always correctly wired, regardless of how the clone was built.
				(function patchStickyLinks() {
					// Logo: copy hrefs from source logo links
					const srcLogoLinks = logoEl ? Array.from(logoEl.querySelectorAll('a')) : [];
					const stickyLogoEl = stickyHeader.querySelector('#logo-sticky');
					if (stickyLogoEl) {
						stickyLogoEl.querySelectorAll('a').forEach(function(a, i) {
							if (srcLogoLinks[i] && srcLogoLinks[i].href) {
								a.href = srcLogoLinks[i].href;
							}
						});
					}
					// Also patch any logo links in the mobile clone (header-container--top)
					const srcLogo = document.querySelector('#logo');
					if (srcLogo) {
						const srcLogoLinksAll = Array.from(srcLogo.querySelectorAll('a'));
						stickyHeader.querySelectorAll('a.logo-img, a.logo-txt').forEach(function(a) {
							const match = srcLogoLinksAll.find(function(s) {
								return s.className === a.className;
							});
							if (match && match.href) a.href = match.href;
						});
					}
					// Login button
					const srcLogin = document.querySelector('.header-auth-btn--login');
					if (srcLogin) {
						stickyHeader.querySelectorAll('.header-auth-btn--login').forEach(function(a) {
							a.href = srcLogin.href;
						});
					}
					// Signup button
					const srcSignup = document.querySelector('.header-auth-btn--signup');
					if (srcSignup) {
						stickyHeader.querySelectorAll('.header-auth-btn--signup').forEach(function(a) {
							a.href = srcSignup.href;
						});
					}
					// Logged-in account icon link
					const srcAccount = document.querySelector('a.area--account');
					if (srcAccount) {
						stickyHeader.querySelectorAll('a.area--account').forEach(function(a) {
							a.href = srcAccount.href;
						});
					}
				})();

				// No nav offset — let the nav centre naturally within the sticky header
				const updateStickyNavOffset = () => {};
				window.addEventListener('resize', updateStickyNavOffset);

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderDeskBound = this.querySelector('.header__bottom');
				const stickyHeaderMobileBound = this.querySelector('.header__top');

				this.SCROLL_StickyHelper = () =>{

					var st = window.scrollY;
					if ( ( st <= 0 || ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
						stickyHeader.classList.remove('show');
						this.style.zIndex = '';
						return;
					}

					if ( st < 0 || Math.abs(lst - st) <= 5 )
						return;	

					if ( st > window.lhp ) {

						if ( st == 0 && stickyHeader.classList.contains('show') ) {

							stickyHeader.classList.remove('show');
							this.style.zIndex = '';

						} else if ( st <= lst && ! stickyHeader.classList.contains('show') ) {

							window.lhp = stickyHeader.offsetTop;
							stickyHeader.classList.add('show');
							this.style.zIndex = '90';

						} else if ( st > lst && stickyHeader.classList.contains('show') ) {
							stickyHeader.classList.remove('show');
							this.style.zIndex = '';
						}

					} 

					window.lst = st;

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});
				
			}

			// drawer connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			});
			if ( this.classList.contains('site-header--alignment-left') ) {
				document.getElementById('site-search-sidebar').classList.remove('sidebar--left');
				document.getElementById('site-search-sidebar').classList.add('sidebar--right');
			}
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
					--window-width: ${document.body.clientWidth}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
				--window-width: ${document.body.clientWidth}px;
			}`;
			document.body.classList.add('header-loaded');

			// submenu masonry

			document.querySelectorAll('.site-nav.style--classic .submenu-masonry').forEach(elm=>{
				if ( Macy ) {
					const submenuMacy = new Macy({
						container: elm,
						columns: parseInt(elm.getAttribute('data-columns')),
						margin: 30
					});
					setTimeout(()=>{
						submenuMacy.reInit();
					}, 100);
				}
			});

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {

				// predictive search (sidebar)

				document.querySelectorAll('[data-js-open-search-drawer').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
						setTimeout(()=>{
							document.querySelector('#search-form-sidebar').focus();
						}, 10)
					});
				});

			} else {

				this.querySelector('search-form').addEventListener('click', e=>{
					e.preventDefault();
					window.location.href = KROWN.settings.routes.search_url;
				});

			}

			// touch menu helpers

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}
			let babyMenuTouch = false;
			document.querySelectorAll('.style--classic .has-babymenu').forEach(elm=>{
				elm.addEventListener('touchstart', e=>{
					elm.firstElementChild.style.pointerEvents = 'none';
					elm.classList.toggle('focus');
					babyMenuTouch = true;
					closeTouchSubmenus(elm,elm.closest('.has-submenu'));
				})
			})
			document.querySelectorAll('.style--classic .has-submenu').forEach(elm=>{
				if ( ! elm.classList.contains('mega-link') ) {
					elm.addEventListener('touchstart', e=>{
						elm.firstElementChild.style.pointerEvents = 'none';
						if ( ! babyMenuTouch ) {
							elm.classList.toggle('focus');
								closeTouchSubmenus(elm);
							}
						babyMenuTouch = false;
					})
				}
			})

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'true');
						}
					}
				});	
				
				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});

			// custom 3-level mega menu hover behaviour
			document.querySelectorAll('.site-nav.style--classic .js-mega-menu-item').forEach(megaItem => {
				const submenu = megaItem.querySelector('.submenu.mega-menu');
				if (!submenu) return;

				const level1Items = submenu.querySelectorAll('.mega-menu__level1-item');
				const panels = submenu.querySelectorAll('.mega-menu__panel');
				const panelsWrapper = submenu.querySelector('.mega-menu__panels');

				const setActivePanelEmptyState = (panel) => {
					if (!panel) return;
					const hasColumns = panel.getAttribute('data-has-columns');
					submenu.setAttribute('data-active-panel-empty', hasColumns === 'false' ? 'true' : 'false');
				};

				if (level1Items.length && panels.length) {
					// initial state
					setActivePanelEmptyState(submenu.querySelector('.mega-menu__panel.is-active') || panels[0]);

					level1Items.forEach((tab, index) => {
						tab.addEventListener('mouseenter', () => {
							level1Items.forEach(t => t.classList.remove('is-active'));
							panels.forEach(p => p.classList.remove('is-active'));
							tab.classList.add('is-active');
							if (panels[index]) {
								panels[index].classList.add('is-active');
								setActivePanelEmptyState(panels[index]);
							}
						});
					});
				}

				const panelsWithColumns = submenu.querySelectorAll('.mega-menu__panel');
				panelsWithColumns.forEach(panel => {
					const columns = panel.querySelectorAll('.mega-menu__column');
					if (columns.length < 2) return;

					columns.forEach((col, currentIndex) => {
						col.addEventListener('mouseenter', () => {
							const expandedCol = panel.querySelector('.mega-menu__column.is-expanded');
							const previousIndex = expandedCol ? Array.from(columns).indexOf(expandedCol) : -1;
							// Moving right (or first open): content expands left to right. Moving left: content expands right to left.
							const expandFromLeft = previousIndex < 0 || currentIndex >= previousIndex;

							columns.forEach(c => {
								c.classList.remove('is-expanded', 'expand-from-right', 'expand-from-left');
							});
							col.classList.add('is-expanded');
							if (col.classList.contains('has-third')) {
								col.classList.add(expandFromLeft ? 'expand-from-right' : 'expand-from-left');
							}
						});
					});
				});

				// Add / remove gradient state on main header + mega menu when hovered
				const headerElement = this; // <main-header>
				const visualHeader = headerElement.querySelector('.site-header');

				const addMegaGradient = () => {
					document.body.classList.add('mega-menu-open');
					headerElement.classList.add('mega-menu-open');
					if (visualHeader) {
						visualHeader.classList.add('mega-menu-open');
					}
					// Also apply state to sticky header instance (desktop sticky header clone)
					let stickyHeaderRoot = document.querySelector('.sticky-header');
					if (stickyHeaderRoot) {
						stickyHeaderRoot.classList.add('mega-menu-open');
					}
					submenu.classList.add('mega-menu-open');
					const shouldDarkMode = headerElement.classList.contains('site-header--absolute') || (stickyHeaderRoot && stickyHeaderRoot.classList.contains('dark-mode'));
					if (shouldDarkMode) {
						document.body.classList.add('dark-mode');
					}
				};

				const removeMegaGradient = () => {
					document.body.classList.remove('mega-menu-open');
					headerElement.classList.remove('mega-menu-open');
					if (visualHeader) {
						visualHeader.classList.remove('mega-menu-open');
					}
					// Remove state from sticky header instance
					const stickyHeaderRoot = document.querySelector('.sticky-header');
					if (stickyHeaderRoot) {
						stickyHeaderRoot.classList.remove('mega-menu-open');
					}
					submenu.classList.remove('mega-menu-open');
					const shouldRemoveDarkMode = (headerElement.classList.contains('site-header--absolute') || (stickyHeaderRoot && stickyHeaderRoot.classList.contains('dark-mode'))) && !document.body.classList.contains('site-header--search-open');
					if (shouldRemoveDarkMode) {
						document.body.classList.remove('dark-mode');
					}
				};

				megaItem.addEventListener('mouseenter', addMegaGradient);
				megaItem.addEventListener('mouseleave', removeMegaGradient);

				// Handle level 3 link hover to swap images and content background (hover the text/link, not the whole li)
				const level3Items = submenu.querySelectorAll('.mega-menu__level3-item');
				level3Items.forEach(level3Item => {
					const link = level3Item.querySelector('a.menu-link');
					if (!link) return;
					const column = level3Item.closest('.mega-menu__column');
					const imageWrapper = column?.querySelector('.mega-menu__image-wrapper');
					const contentEl = level3Item.closest('.mega-menu__content:not(.origin)');
					if (!imageWrapper) return;

					const level3ImageUrl = level3Item.getAttribute('data-level3-image-url');
					const level2ImageUrl = level3Item.getAttribute('data-level2-image-url') || imageWrapper.getAttribute('data-level2-image-url');
					const level3BgColor = level3Item.getAttribute('data-level3-bg-color');

					const clearContentBackground = () => {
						if (contentEl) {
							contentEl.style.background = '';
						}
					};

					link.addEventListener('mouseenter', () => {
						// Content background: use 3rd level collection metafield color when hovering that item
						if (contentEl && level3BgColor && level3BgColor !== '') {
							contentEl.style.background = level3BgColor;
						}
						// Only show hover image when level 3 has its own image; otherwise keep default (level 2) image visible
						if (level3ImageUrl && level3ImageUrl !== '') {
							// Level 3 has image: show it in the hover layer
							let hoverImageElement = imageWrapper.querySelector('.mega-menu__image--hover');
							if (!hoverImageElement) {
								hoverImageElement = document.createElement('div');
								hoverImageElement.className = 'mega-menu__image mega-menu__image--hover';
								imageWrapper.appendChild(hoverImageElement);
							}
							hoverImageElement.style.backgroundImage = `url(${level3ImageUrl})`;
							hoverImageElement.style.opacity = '1';

							const defaultImage = imageWrapper.querySelector('.mega-menu__image--default, .lazy-image--background, .mega-menu__image--placeholder');
							if (defaultImage) {
								defaultImage.style.opacity = '0';
							}
						} else {
							// Level 3 has no image: hide hover layer, keep default (level 2) image visible
							const hoverImage = imageWrapper.querySelector('.mega-menu__image--hover');
							if (hoverImage) {
								hoverImage.style.opacity = '0';
							}
							const defaultImage = imageWrapper.querySelector('.mega-menu__image--default, .lazy-image--background, .mega-menu__image--placeholder');
							if (defaultImage) {
								defaultImage.style.opacity = '1';
							}
						}
					});

					link.addEventListener('mouseleave', () => {
						clearContentBackground();
						// Reset to default image
						const hoverImage = imageWrapper.querySelector('.mega-menu__image--hover');
						if (hoverImage) {
							hoverImage.style.opacity = '0';
						}
						const defaultImage = imageWrapper.querySelector('.mega-menu__image--default, .lazy-image--background, .mega-menu__image--placeholder');
						if (defaultImage) {
							defaultImage.style.opacity = '1';
						}
					});
				});

				// Reset image and content background when leaving the column
				const columns = submenu.querySelectorAll('.mega-menu__column.has-third');
				columns.forEach(column => {
					column.addEventListener('mouseleave', () => {
						const imageWrapper = column.querySelector('.mega-menu__image-wrapper');
						if (imageWrapper) {
							const hoverImage = imageWrapper.querySelector('.mega-menu__image--hover');
							if (hoverImage) {
								hoverImage.style.opacity = '0';
							}
							const defaultImage = imageWrapper.querySelector('.mega-menu__image--default, .lazy-image--background, .mega-menu__image--placeholder');
							if (defaultImage) {
								defaultImage.style.opacity = '1';
							}
						}
						const contentEl = column.querySelector('.mega-menu__content:not(.origin)');
						if (contentEl) {
							contentEl.style.background = '';
						}
					});
				});
			});

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			this._opened = true;
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			if ( this.id == 'site-cart-sidebar' && document.getElementById('cart-recommendations-sidebar') ) {
				setTimeout(()=>{
					document.querySelector('#cart-recommendations-sidebar css-slider')?.resetSlider();
				}, 10);
			}
			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					elm.setAttribute('inert', '');
				})
			}, 15);

		}

		hide(){

			this._opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						this.classList.add('opened-second-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						this._resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this._resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

		}

		_resizeContainer(main=false){
			if ( main ) {
				this.style.height = `auto`;
			} else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.opened .submenu').scrollHeight}px`;
				}  
			}
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}